import { Injectable, Injector } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { EmployeeRoleResource } from '../models/resource/employee-role.resource';
import { Role } from '../models/ui/role.model';
import { EmployeeRoleResourceToRoleMapper } from '../models/mappers/employee-role-resource-to-role.mapper';

const roleMapper = new EmployeeRoleResourceToRoleMapper();

@Injectable({ providedIn: 'root' })
export class EmployeeRoleSdk extends SdkBase {

	constructor(injector: Injector) {
		super(injector);
	}

	public getEmployeeRoles(): Observable<Role[]> {
		return this.makeHttpRequest<EmployeeRoleResource[]>('get', `api2/employeeroles`).pipe(
			map((response) => {
				return roleMapper.mapCollection(response);
			})
		);
	}

	public updateUserEmployeeRoles(params: UpdateUserEmployeeRolesParams): Observable<void> {
		return this.makeHttpRequest<any>('patch', `api2/users/${params.userId}/employeeroles`, params.roles);
	}
}

interface UpdateUserEmployeeRolesParams {
	userId: string;
	roles: string[];
}
